<template>
  <div class="docs-wrapper">
    <v-row no-gutters class="docs-row">

      <!-- INFORMES -->
      <v-col :cols="colSize" v-if="showReports" class="docs-col">
        <div class="docs-section">
          <div class="docs-header">
            <v-icon size="14">mdi-file-document-outline</v-icon>
            <span class="docs-title">Informes</span>
            <span class="docs-count" v-if="reports?.length">{{ reports.length }}</span>
          </div>

          <p class="docs-empty" v-if="reports?.length == 0">{{ showInPreparation ? 'No hay informes' : 'Sin informes enviados' }}</p>

          <div
            class="doc-item"
            v-for="(document, index) in reports"
            :key="'r' + index"
            @click="toReportDetail(document)"
          >
            <div class="doc-item-body">
              <span class="doc-label">
                {{ document.serial?.serial }} · LP{{ item.project_line_info?.project_line?.number }}
                · {{ document.prefix?.prefix }} {{ document.report_index }}
                <template v-if="document.report_index > 1"> · #{{ document.report_index }}</template>
              </span>
              <span class="doc-date">{{ document.created_at | toDate }}</span>
            </div>
            <v-chip
              :color="document.last_status?.status | budgetStatusColor"
              label outlined x-small class="doc-chip"
            >
              <b>{{ document.last_status?.status | budgetStatus }}</b>
            </v-chip>
          </div>
        </div>
      </v-col>

      <div class="docs-divider" v-if="showReports && (showBudgets || showContracts)"></div>

      <!-- PRESUPUESTOS -->
      <v-col :cols="colSize" v-if="showBudgets" class="docs-col">
        <div class="docs-section">
          <div class="docs-header">
            <v-icon size="14">mdi-book-outline</v-icon>
            <span class="docs-title">Presupuestos</span>
            <span class="docs-count" v-if="(budgets?.length + report_budgets?.length) > 0">
              {{ (budgets?.length || 0) + (report_budgets?.length || 0) }}
            </span>
          </div>

          <p class="docs-empty" v-if="budgets?.length == 0 && report_budgets?.length == 0">{{ showInPreparation ? 'No hay presupuestos' : 'Sin presupuestos enviados' }}</p>

          <div
            class="doc-item"
            v-for="(document, index) in budgets"
            :key="'b' + index"
            @click="toBudget(document)"
          >
            <div class="doc-item-body">
              <span class="doc-label">
                {{ document.serial?.serial }} · LP{{ item.project_line_info?.project_line?.number }}
                · {{ document.prefix?.prefix }} {{ document.report_index }}
              </span>
              <span class="doc-date">{{ document.created_at | toDate }}</span>
            </div>
            <v-chip
              :color="document.last_status?.status | budgetStatusColor"
              label outlined x-small class="doc-chip"
            >
              <b>{{ document.last_status?.status | budgetStatus }}</b>
            </v-chip>
          </div>

          <div
            class="doc-item"
            v-for="(document, index) in report_budgets"
            :key="'rb' + index"
            @click="toReportDetail(document)"
          >
            <div class="doc-item-body">
              <span class="doc-badge">Desarchivo</span>
              <span class="doc-label">
                {{ document.serial?.serial }} · LP{{ item.project_line_info?.project_line?.number }}
                · {{ document.prefix?.prefix }} {{ document.report_index }}
              </span>
              <span class="doc-date">{{ document.created_at | toDate }}</span>
            </div>
            <v-chip
              :color="document.last_status?.status | budgetStatusColor"
              label outlined x-small class="doc-chip"
            >
              <b>{{ document.last_status?.status | budgetStatus }}</b>
            </v-chip>
          </div>
        </div>
      </v-col>

      <div class="docs-divider" v-if="showBudgets && showContracts"></div>

      <!-- CONTRATOS -->
      <v-col :cols="colSize" v-if="showContracts" class="docs-col">
        <div class="docs-section">
          <div class="docs-header">
            <v-icon size="14">mdi-briefcase</v-icon>
            <span class="docs-title">Contratos</span>
            <span class="docs-count" v-if="contracts?.length">{{ contracts.length }}</span>
          </div>

          <p class="docs-empty" v-if="contracts?.length == 0">{{ showInPreparation ? 'No hay contratos' : 'Sin contratos enviados' }}</p>

          <div
            class="doc-item"
            v-for="(document, index) in contracts"
            :key="'c' + index"
            @click="toContractDetail(document)"
          >
            <div class="doc-item-body">
              <span class="doc-label">
                {{ document.serial?.serial }} · LP{{ item.project_line_info?.project_line?.number }}
                · {{ document.prefix?.prefix }} {{ document.report_index }}
              </span>
              <span class="doc-date">{{ document.created_at | toDate }}</span>
            </div>
            <v-chip
              :color="document.last_status?.status | contractStatusColor"
              label outlined x-small class="doc-chip"
            >
              <b>{{ document.last_status?.status | contractStatus }}</b>
            </v-chip>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import budgetStatuses from '@/components/Helpers/Constants/budget.js'

export default {
	name: 'Documents',
	components: {},
	props: {
		item: {
			type: Object,
			required: true
		},
		fullWidth: {
			type: Boolean,
			default: false
		},
		showReports: {
			type: Boolean,
			default: true
		},
		showBudgets: {
			type: Boolean,
			default: true
		},
		showContracts: {
			type: Boolean,
			default: true
		},
		showInPreparation: {
			type: Boolean,
			default: false
		},
	},
  data() {
    return {
			budgetStatuses,
			loading: false,
			filesToUpload: [],
			loadingRemoveFile: false,
    };
  },
  computed: {
		colSize(){
			if(this.fullWidth){
				return 12
			}
			return 4
		},
		reports(){
			if(this.item.reports?.length){
				return this.item.reports.filter((report) => {
					if(!this.showInPreparation){
						return report.last_status?.status >= this.budgetStatuses.ENVIADO_CONTRAPARTE
										&& report.pdf?.file?.file_link
										&& report.prefix_id != 5
					}
					return report.prefix_id != 5
				})
			}
			return []
		},
		report_budgets(){
			if(this.item.reports?.length){
				return this.item.reports.filter((report) => {
					if(!this.showInPreparation){
						return report.last_status?.status >= this.budgetStatuses.ENVIADO_CONTRAPARTE
										&& report.pdf?.file?.file_link
										&& report.prefix_id == 5
					}
					return report.prefix_id == 5
				})
			}
			return []
		},
		budgets(){
			if(this.item.budgets?.length){
				return this.item.budgets.filter((budget) => {
					if(!this.showInPreparation){
						return budget.last_status?.status >= this.budgetStatuses.ENVIADO_CONTRAPARTE && budget.pdf?.file?.file_link
					}
					return true
				})
			}
			return []
		},
		contracts(){
			if(this.item.contracts?.length){
				return this.item.contracts.filter((contract) => {
					if(!this.showInPreparation){
						return contract.last_status?.status >= this.budgetStatuses.ENVIADO_CONTRAPARTE && contract.pdf?.file?.file_link
					}
					return true
				})
			}
			return []
		}
  },
	watch: {
	},
	mounted(){
		console.log('conversation',this.item)
	},
	beforeDestroy(){
	},
  methods: {
		toBudget(budget){
			if(budget.last_status?.status >= this.budgetStatuses.ENVIADO_CONTRAPARTE && budget.pdf?.file?.file_link){
				window.open(
					`${budget.pdf?.file?.file_link}`,
					'',
					'width=1000,height=700,toolbar=no,menubar=no,location=no,status=no'
				);
			}
			else{
				this.$store.commit('budget/setBudgetComponentModalId', budget.id)
			}
		},
		toContractDetail(contract){
			if(contract.last_status?.status >= this.budgetStatuses.ENVIADO_CONTRAPARTE && contract.pdf?.file?.file_link){
				window.open(
					`${contract.pdf?.file?.file_link}`,
					'',
					'width=1000,height=700,toolbar=no,menubar=no,location=no,status=no'
				);
			}
			else{
				this.$store.commit('contracts/setContractComponentModalId', {contract_id: contract.id, status: true})
			}
		},
		toReportDetail(report){
			if(report.last_status?.status >= this.budgetStatuses.ENVIADO_CONTRAPARTE && report.pdf?.file?.file_link){
				window.open(
					`${report.pdf?.file?.file_link}`,
					'',
					'width=1000,height=700,toolbar=no,menubar=no,location=no,status=no'
				);
			}
			else{
				this.$store.commit('reports/setReportComponentModalId', {report_id:report.id, status: true})
			}
		},
  },
};
</script>

<style scoped>
.documents-container{
	/* border: 1px solid #dedede; */
}
.document-container{
	border: 1px solid #d5d5d5;
	background-color: #fbfbfb;
	cursor: pointer;
}
.document-container:hover{
	background-color: #f3f3f3;
}

.docs-wrapper {
	font-family: inherit;
}

.docs-row {
	gap: 0;
}

.docs-col {
	min-width: 0;
}

.docs-section {
	padding: 8px 10px;
	height: 100%;
}

.docs-header {
	display: flex;
	align-items: center;
	gap: 5px;
	margin-bottom: 6px;
	padding-bottom: 5px;
	border-bottom: 1px solid rgba(0,0,0,0.08);
}

.docs-icon {
	font-size: 12px;
	line-height: 1;
}

.docs-title {
	font-size: 11px;
	font-weight: 700;
	letter-spacing: 0.04em;
	text-transform: uppercase;
	color: rgba(0,0,0,0.6);
	flex: 1;
}

.docs-count {
	font-size: 10px;
	font-weight: 700;
	background: rgba(0,0,0,0.07);
	color: rgba(0,0,0,0.5);
	border-radius: 10px;
	padding: 1px 6px;
	line-height: 16px;
}

.docs-empty {
	font-size: 11px;
	color: rgba(0,0,0,0.35);
	font-style: italic;
	margin: 4px 0 0;
	padding: 0;
}

.doc-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 6px;
	padding: 5px 7px;
	border-radius: 6px;
	margin-bottom: 3px;
	cursor: pointer;
	background: rgba(0,0,0,0.02);
	border: 1px dashed rgba(0,0,0,0.06);
	transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}

.doc-item:hover {
	background: rgba(0,0,0,0.05);
	border-color: rgba(0,0,0,0.13);
	transform: translateY(-1px);
}

.doc-item-body {
	display: flex;
	flex-direction: column;
	gap: 1px;
	min-width: 0;
	overflow: hidden;
}

.doc-badge {
	font-size: 9px;
	font-weight: 700;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	color: #9e6700;
	background: #fff3cd;
	border-radius: 3px;
	padding: 0 4px;
	display: inline-block;
	width: fit-content;
	margin-bottom: 1px;
}

.doc-label {
	font-size: 11px;
	font-weight: 600;
	color: rgba(0,0,0,0.75);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: block;
}

.doc-date {
	font-size: 10px;
	color: rgba(0,0,0,0.4);
}

.doc-chip {
	flex-shrink: 0;
}

.docs-divider {
	width: 1px;
	background: rgba(0,0,0,0.08);
	margin: 6px 0;
	align-self: stretch;
}
</style>